/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : AddButtonV2.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Button } from "@mui/material";
import React from "react";
import AddIcon from "@mui/icons-material/Add";
import DownloadIcon from "@mui/icons-material/Download";
import RefreshIcon from "@mui/icons-material/Refresh";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { UploadFile } from "@mui/icons-material";
function AddButtonV2({
  size,
  variant = "contained",
  type = "submit",
  handleOnClick,
  disabled = false,
  btnStyle,
  icon,
}) {
  const getIcon = () => {
    switch (icon) {
      case "download":
        return <DownloadIcon fontSize="small" />;
      case "refresh":
        return <RefreshIcon fontSize="small" />;
      case "upload":
        return <UploadFile fontSize="small" />;
      case "edit":
        return <BorderColorIcon fontSize="small" />;
      default:
        return <AddIcon fontSize="small" />;
    }
  };

  return (
    <Button
      size={size}
      variant={variant}
      onClick={handleOnClick}
      disabled={disabled}
      sx={{
        textTransform: "none",
        borderRadius: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "24px",
        width: "24px",
        minWidth: "20px", // ✅ Prevents MUI default 64px width
        padding: 0, // ✅ Removes internal padding
        fontFamily: "'Open Sans', sans-serif",

        ...(type === "submit"
          ? icon === "edit"
            ? {
                backgroundColor: "transparent",
                color: "#000000",
                boxShadow: "none",
                "&:hover": { backgroundColor: "#EBEBEB" },
              }
            : {
              backgroundColor: "#26890D",
              color: "white",
              "&:hover": { backgroundColor: "#20730B" },
              "&.Mui-disabled": {
                backgroundColor: "#A8D09E",
                color: "white",
                cursor: "not-allowed",
              },
              boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
            }
          : type === "cancel"
            ? {
                backgroundColor: "transparent",
                color: "#000000",
                border: "2px solid #000000",
                "&:hover": {
                  borderColor: "#000000",
                  color: "#000000",
                  backgroundColor: "#EBEBEB",
                },
                "&.Mui-disabled": {
                  backgroundColor: "transparent",
                  borderColor: "#DDDDDD",
                  color: "#DDDDDD",
                  cursor: "not-allowed",
                },
              }
            : type === "other"
              ? {
                  backgroundColor: "transparent",
                  color: "#26890D",
                  border: "2px solid #26890D",
                  "&:hover": {
                    borderColor: "#26890D",
                    color: "#26890D",
                    backgroundColor: "#EBEBEB",
                  },
                  "&.Mui-disabled": {
                    backgroundColor: "transparent",
                    borderColor: "#DDDDDD",
                    color: "#DDDDDD",
                    cursor: "not-allowed",
                  },
                }
              : {}),

        ...(btnStyle || {}),
      }}
    >
      {getIcon()}
    </Button>
  );
}

export default AddButtonV2;
